// Legal content — FR / EN. Style-only rendering handled by LegalPage.
// Section body items: string = paragraph; {list:[...]}; {addr:[...]}; {sub:"..."}
export const ROUTES = {
  legal: "/mentions-legales",
  privacy: "/politique-de-confidentialite",
};

const EDITOR_FR = [
  "Bardine Project Advisory",
  "Nicola Bardine",
  "Rue Étienne-Dumont 18",
  "1204 Genève, Suisse",
  "Téléphone : +41 77 433 86 87",
  "E-mail : nicola@bardinepa.ch",
  "Site : www.bardinepa.ch",
];
const EDITOR_EN = [
  "Bardine Project Advisory",
  "Nicola Bardine",
  "Rue Étienne-Dumont 18",
  "1204 Geneva, Switzerland",
  "Telephone: +41 77 433 86 87",
  "Email: nicola@bardinepa.ch",
  "Website: www.bardinepa.ch",
];

export const legalContent = {
  fr: {
    legal: {
      title: "Mentions légales",
      updated: "Dernière mise à jour : 9 septembre 2026.",
      sections: [
        { h: "Éditeur du site", body: [{ addr: EDITOR_FR }] },
        { h: "Responsable de la publication", body: ["Nicola Bardine"] },
        {
          h: "Hébergement",
          body: [
            "Ce site est hébergé par Emergent, sur une infrastructure cloud.",
            { addr: ["Emergent", "Site : https://emergent.sh"] },
          ],
        },
        {
          h: "Propriété intellectuelle",
          body: [
            "L'ensemble des contenus présents sur ce site, notamment les textes, photographies, images, éléments graphiques, logos, documents, structure et présentation, est protégé par le droit de la propriété intellectuelle.",
            "Toute reproduction, représentation, adaptation, modification, diffusion ou utilisation, totale ou partielle, de ces contenus sans autorisation écrite préalable de Bardine Project Advisory est interdite, sous réserve des exceptions prévues par la législation applicable.",
          ],
        },
        {
          h: "Responsabilité",
          body: [
            "Bardine Project Advisory veille à fournir des informations exactes et actualisées. Toutefois, aucune garantie ne peut être donnée quant à l'exhaustivité ou à l'actualité permanente des informations publiées.",
            "Les informations disponibles sur ce site sont fournies à titre général et ne constituent ni une offre contractuelle ni un conseil technique, juridique ou financier adapté à une situation particulière.",
            "Bardine Project Advisory ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site, de l'impossibilité d'y accéder ou de l'utilisation des informations qui y sont publiées.",
          ],
        },
        {
          h: "Liens externes",
          body: [
            "Le site peut contenir des liens vers des sites internet exploités par des tiers. Bardine Project Advisory n'exerce aucun contrôle sur leur contenu et décline toute responsabilité concernant leur disponibilité, leur sécurité ou leurs pratiques en matière de protection des données.",
          ],
        },
      ],
    },
    privacy: {
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : 9 septembre 2026.",
      intro:
        "Bardine Project Advisory accorde une importance particulière à la protection des données personnelles et traite celles-ci conformément à la législation suisse applicable, notamment la Loi fédérale sur la protection des données.",
      sections: [
        { h: "Responsable du traitement", body: [{ addr: EDITOR_FR.slice(0, 6) }] },
        {
          h: "Données susceptibles d'être collectées",
          body: [
            "Lorsque vous utilisez ce site, les données suivantes peuvent être collectées :",
            {
              list: [
                "nom et prénom ;",
                "adresse e-mail ;",
                "numéro de téléphone ;",
                "entreprise et fonction professionnelle ;",
                "contenu des messages envoyés au moyen du formulaire de contact ;",
                "informations communiquées lors d'une demande de rendez-vous ;",
                "adresse IP, type de navigateur, appareil utilisé et données techniques de connexion ;",
                "préférence de langue enregistrée localement dans votre navigateur.",
              ],
            },
          ],
        },
        {
          h: "Finalités du traitement",
          body: [
            "Les données sont utilisées exclusivement pour :",
            {
              list: [
                "répondre aux demandes de contact ;",
                "organiser un rendez-vous ou un échange professionnel ;",
                "préparer, établir ou exécuter une relation contractuelle ;",
                "assurer le fonctionnement, la sécurité et l'amélioration du site ;",
                "respecter les obligations légales applicables.",
              ],
            },
          ],
        },
        {
          h: "Base et proportionnalité du traitement",
          body: [
            "Les données sont traitées lorsque cela est nécessaire pour répondre à une demande, préparer ou exécuter un contrat, respecter une obligation légale ou poursuivre l'intérêt légitime de Bardine Project Advisory à exploiter et sécuriser son site.",
            "Lorsque le consentement est requis, notamment pour certains outils de suivi ou de marketing, les données ne sont traitées qu'après obtention de ce consentement.",
          ],
        },
        {
          h: "Destinataires et prestataires",
          body: [
            "Les données peuvent être accessibles aux prestataires techniques strictement nécessaires au fonctionnement du site :",
            {
              list: [
                "Emergent — hébergement du site (https://emergent.sh) ;",
                "Resend — envoi des e-mails liés aux formulaires ;",
                "MongoDB — base de données pour l'enregistrement des demandes ;",
                "Google Fonts — polices de caractères chargées depuis les serveurs de Google.",
              ],
            },
            "Ces prestataires ne peuvent traiter les données que dans le cadre des services qu'ils fournissent.",
          ],
        },
        {
          h: "Transferts internationaux",
          body: [
            "Certains de ces prestataires (notamment Emergent, Resend et Google) sont susceptibles de traiter des données en dehors de la Suisse, en particulier aux États-Unis. Dans ce cas, Bardine Project Advisory veille à ce que le transfert repose sur un niveau de protection reconnu ou sur des garanties contractuelles appropriées.",
          ],
        },
        {
          h: "Durée de conservation",
          body: [
            "Les demandes de contact et la correspondance professionnelle sont conservées pendant la durée nécessaire à leur traitement, puis pendant une durée maximale de 24 mois, sauf lorsqu'une conservation plus longue est nécessaire pour une relation contractuelle, une obligation légale ou la défense de droits.",
            "Les données techniques et journaux de sécurité sont conservés uniquement pendant la durée nécessaire à la sécurité et au fonctionnement du site.",
            "La préférence de langue est stockée localement dans votre navigateur jusqu'à sa suppression manuelle.",
          ],
        },
        {
          h: "Cookies",
          body: [
            "Ce site utilise uniquement les technologies strictement nécessaires à son fonctionnement, à sa sécurité et à la transmission des formulaires. Aucun cookie publicitaire ou de suivi marketing n'est utilisé.",
          ],
        },
        {
          h: "Droits des personnes concernées",
          body: [
            "Toute personne concernée peut, dans les limites prévues par la législation applicable, demander :",
            {
              list: [
                "l'accès à ses données personnelles ;",
                "la rectification de données inexactes ;",
                "la suppression de ses données ;",
                "la limitation ou l'opposition à certains traitements ;",
                "la remise de ses données dans un format électronique courant lorsque les conditions légales sont réunies ;",
                "le retrait de son consentement pour l'avenir.",
              ],
            },
            "Les demandes peuvent être adressées à : nicola@bardinepa.ch.",
          ],
        },
        {
          h: "Sécurité",
          body: [
            "Bardine Project Advisory met en œuvre des mesures techniques et organisationnelles raisonnables afin de protéger les données contre la perte, l'accès non autorisé, l'utilisation abusive ou la divulgation.",
            "Aucune transmission de données par internet ne peut toutefois être garantie comme entièrement sécurisée.",
          ],
        },
        {
          h: "Modifications",
          body: [
            "Cette politique peut être modifiée afin de tenir compte de l'évolution du site, des services utilisés ou de la législation. La version publiée sur cette page est la version applicable.",
          ],
        },
      ],
    },
  },

  en: {
    legal: {
      title: "Legal Notice",
      updated: "Last updated: 9 September 2026.",
      sections: [
        { h: "Website publisher", body: [{ addr: EDITOR_EN }] },
        { h: "Publication manager", body: ["Nicola Bardine"] },
        {
          h: "Hosting",
          body: [
            "This website is hosted by Emergent, on cloud infrastructure.",
            { addr: ["Emergent", "Website: https://emergent.sh"] },
          ],
        },
        {
          h: "Intellectual property",
          body: [
            "All content available on this website, including texts, photographs, images, graphic elements, logos, documents, structure and presentation, is protected by intellectual-property law.",
            "Any reproduction, representation, adaptation, modification, distribution or use, in whole or in part, without the prior written authorisation of Bardine Project Advisory is prohibited, subject to the exceptions provided by applicable law.",
          ],
        },
        {
          h: "Liability",
          body: [
            "Bardine Project Advisory endeavours to provide accurate and up-to-date information. However, no guarantee can be given regarding the completeness or continuous accuracy of the information published.",
            "The information on this website is provided for general purposes and does not constitute a contractual offer or technical, legal or financial advice tailored to a particular situation.",
            "Bardine Project Advisory cannot be held liable for direct or indirect damage arising from use of the website, inability to access it or reliance on the information published on it.",
          ],
        },
        {
          h: "External links",
          body: [
            "This website may contain links to websites operated by third parties. Bardine Project Advisory has no control over their content and accepts no responsibility for their availability, security or data-protection practices.",
          ],
        },
      ],
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Last updated: 9 September 2026.",
      intro:
        "Bardine Project Advisory attaches particular importance to the protection of personal data and processes it in accordance with applicable Swiss legislation, including the Swiss Federal Act on Data Protection.",
      sections: [
        { h: "Data controller", body: [{ addr: EDITOR_EN.slice(0, 6) }] },
        {
          h: "Data that may be collected",
          body: [
            "When you use this website, the following data may be collected:",
            {
              list: [
                "first and last name;",
                "email address;",
                "telephone number;",
                "company and professional role;",
                "content of messages submitted through the contact form;",
                "information provided when requesting an appointment;",
                "IP address, browser type, device and technical connection data;",
                "language preference stored locally in your browser.",
              ],
            },
          ],
        },
        {
          h: "Purposes of processing",
          body: [
            "Personal data is used exclusively to:",
            {
              list: [
                "respond to enquiries;",
                "organise appointments and professional discussions;",
                "prepare, establish or perform a contractual relationship;",
                "operate, secure and improve the website;",
                "comply with applicable legal obligations.",
              ],
            },
          ],
        },
        {
          h: "Basis and proportionality of processing",
          body: [
            "Data is processed where necessary to respond to a request, prepare or perform a contract, comply with a legal obligation or pursue Bardine Project Advisory's legitimate interest in operating and securing its website.",
            "Where consent is required, particularly for certain tracking or marketing tools, data will only be processed after consent has been obtained.",
          ],
        },
        {
          h: "Recipients and service providers",
          body: [
            "Personal data may be accessible to technical providers strictly necessary for operating the website:",
            {
              list: [
                "Emergent — website hosting (https://emergent.sh);",
                "Resend — sending of form-related emails;",
                "MongoDB — database used to store requests;",
                "Google Fonts — typefaces loaded from Google servers.",
              ],
            },
            "These providers may only process data in connection with the services they provide.",
          ],
        },
        {
          h: "International transfers",
          body: [
            "Some of these providers (in particular Emergent, Resend and Google) may process data outside Switzerland, in particular in the United States. In such cases, Bardine Project Advisory ensures that the transfer is based on a recognised level of protection or appropriate contractual safeguards.",
          ],
        },
        {
          h: "Retention period",
          body: [
            "Contact requests and professional correspondence are retained for as long as necessary to process the request and for a maximum of 24 months thereafter, unless longer retention is required for a contractual relationship, legal obligation or the establishment or defence of legal rights.",
            "Technical data and security logs are retained only for as long as necessary to secure and operate the website.",
            "The language preference is stored locally in your browser until you delete it manually.",
          ],
        },
        {
          h: "Cookies",
          body: [
            "This website uses only technologies strictly necessary for its operation, security and form submission. No advertising or marketing-tracking cookies are used.",
          ],
        },
        {
          h: "Individual rights",
          body: [
            "Within the limits of applicable law, individuals may request:",
            {
              list: [
                "access to their personal data;",
                "correction of inaccurate data;",
                "deletion of their data;",
                "restriction of or objection to certain processing;",
                "delivery of their data in a commonly used electronic format where the legal requirements are met;",
                "withdrawal of consent for future processing.",
              ],
            },
            "Requests may be sent to: nicola@bardinepa.ch.",
          ],
        },
        {
          h: "Security",
          body: [
            "Bardine Project Advisory implements reasonable technical and organisational measures to protect personal data against loss, unauthorised access, misuse or disclosure.",
            "However, no transmission of data over the internet can be guaranteed to be completely secure.",
          ],
        },
        {
          h: "Changes",
          body: [
            "This policy may be amended to reflect changes to the website, the services used or applicable legislation. The version published on this page is the applicable version.",
          ],
        },
      ],
    },
  },
};
